import { useEffect, useState } from "react";
import api from "../services/api";
import CustomSelect from "./CustomSelect";
import '../styles/dashboard.css';
import pilgrim from '../assets/images/small/pilgrim.svg';
import city from '../assets/images/small/City.svg';
import stateIcon from '../assets/images/small/State.svg';

const StateCityFilter = ({ onChange, fetchCards }) => {
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [servicePlan, setServicePlan] = useState("");
  const [statusValue, setStatusValue] = useState("");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [plans, setPlans] = useState([]);

  const [cityLoading, setCityLoading] = useState(false);

  // ✅ STATIC STATUS (FIXED)
  const statusOptions = [
    { label: "Active", value: "1" },
    { label: "Inactive", value: "0" },
  ];

  // --------------------
  // FETCH STATES
  // --------------------
  const fetchStates = async () => {
    try {
      const res = await api.get("/api/Dashboard/user_state_list");
      if (res.data.status === "success") {
        setStates(res.data.data);
      }
    } catch (error) {
      console.error("State API Error:", error);
    }
  };

  // --------------------
  // FETCH CITIES
  // --------------------
  const fetchCities = async (selectedState) => {
    if (!selectedState) {
      setCities([]);
      return;
    }

    setCityLoading(true);

    try {
      const formData = new FormData();
      formData.append("statename", selectedState);

      const res = await api.post("/api/Dashboard/user_city_list", formData);

      if (res.data.status === "success") {
        setCities(res.data.data);
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error("City API Error:", error);
      setCities([]);
    } finally {
      setCityLoading(false);
    }
  };

  // --------------------
  // FETCH SERVICE PLANS
  // --------------------
  const fetchPlans = async () => {
    try {
      const res = await api.get("/service-plan/get-all");
      if (res.data.status === "success") {
        setPlans(res.data.data);
      }
    } catch (error) {
      console.error("Service Plan API Error:", error);
    }
  };

  // --------------------
  // INITIAL LOAD
  // --------------------
  useEffect(() => {
    fetchStates();
    fetchPlans();
  }, []);

  // --------------------
  // STATE CHANGE
  // --------------------
  useEffect(() => {
    setCityName("");
    fetchCities(stateName);
    triggerChange(stateName, "", servicePlan, statusValue);
  }, [stateName]);

  // --------------------
  // CITY CHANGE
  // --------------------
  useEffect(() => {
    triggerChange(stateName, cityName, servicePlan, statusValue);
  }, [cityName]);

  // --------------------
  // SERVICE PLAN CHANGE
  // --------------------
  useEffect(() => {
    triggerChange(stateName, cityName, servicePlan, statusValue);
  }, [servicePlan]);

  // --------------------
  // STATUS CHANGE
  // --------------------
  useEffect(() => {
    triggerChange(stateName, cityName, servicePlan, statusValue);
  }, [statusValue]);

  // --------------------
  // COMMON CHANGE HANDLER (FIXED)
  // --------------------
  const triggerChange = (selectedState, selectedCity, plan, statusVal) => {
    if (onChange) {
      onChange({
        state: selectedState,
        city: selectedCity,
        servicePlan: plan,
        status: statusVal,
      });
    }
  };

  return (
    <div className="filter-containers" style={{ width: "100%" }}>
      <form onSubmit={(e) => {
        e.preventDefault();
        if (fetchCards) {
          fetchCards();
        }
      }}>

        {/* STATE */}
        <div className="filter-form-container">
          <div className="label-container">
            <div className="image-container">
              <img src={stateIcon} alt="state" />
            </div>
            <p>State</p>
          </div>
          <CustomSelect
            options={states}
            value={stateName}
            onChange={(val) => setStateName(val)}
            labelKey="statename"
            valueKey="statename"
            placeholder="All States"
          />
        </div>

        {/* CITY */}
        <div className="filter-form-container">
          <div className="label-container">
            <div className="image-container">
              <img src={city} alt="city" />
            </div>
            <p>City</p>
          </div>
          <CustomSelect
            options={cities}
            value={cityName}
            onChange={(val) => setCityName(val)}
            labelKey="cityname"
            valueKey="cityname"
            placeholder={
              cityLoading
                ? "Loading cities..."
                : stateName
                ? "All Cities"
                : "Select State First"
            }
            disabled={!stateName || cityLoading}
          />
        </div>

        {/* STATUS (FIXED) */}
        <div className="filter-form-container">
          <div className="label-container">
            <div className="image-container">
              <img src={stateIcon} alt="status" />
            </div>
            <p>Status</p>
          </div>
          <CustomSelect
            options={statusOptions}
            value={statusValue}
            onChange={(val) => setStatusValue(val)}
            labelKey="label"
            valueKey="value"
            placeholder="All Status"
          />
        </div>

        {/* SERVICE PLAN */}
        <div className="filter-form-container">
          <div className="label-container">
            <div className="image-container">
              <img src={pilgrim} alt="plan" />
            </div>
            <p>Service Plan</p>
          </div>
          <CustomSelect
            options={plans}
            value={servicePlan}
            onChange={(val) => setServicePlan(val)}
            labelKey="plan_name"
            valueKey="id"
            placeholder="All Plans"
          />
        </div>

        {/* APPLY BUTTON */}
        <div className="filter-form-container">
          <button className="apply-filters" type="submit">
            Apply Filter
          </button>
        </div>

      </form>
    </div>
  );
};

export default StateCityFilter;